import { Button, Flex } from '@bridebook/aura';
import { useCopyToClipboardWithFeedback } from '@bridebook/web/lib/utils/hooks/use-copy-to-clipboard-with-feedback';
import { useTranslation } from 'next-i18next';
import { DISCOUNT_CODE, TICKETS_URL } from './constants';
import { memo } from 'react';

const NWSDiscountCardUnlocked = () => {
  const { t } = useTranslation('articles');
  const { isCopied, copy } = useCopyToClipboardWithFeedback({ delay: 1800 });

  return (
    <>
      <span className="w-fit rounded-full bg-teal-40 px-2.5 py-1.5 typo-2xs font-bold tracking-[0.1em] text-teal-120 uppercase">
        {t('nwsDiscountCard.unlocked.badge')}
      </span>
      <h2 className="!my-0 !text-2xl leading-tight !font-extrabold text-pretty">
        {t('nwsDiscountCard.unlocked.title')}
      </h2>
      <p className="!mb-0 typo-sm text-pretty text-space-75">
        {t('nwsDiscountCard.unlocked.description')}
      </p>

      <div className="grid grid-cols-2 gap-2.5">
        <Flex className="flex-col gap-1 rounded-2xl bg-indigo-crush-04 p-3.5">
          <span className="typo-lg font-extrabold text-indigo-crush">
            {t('nwsDiscountCard.standardSave')}
          </span>
          <span className="typo-xs text-space-75">{t('nwsDiscountCard.standardSaveLabel')}</span>
          <span className="typo-2xs text-space-60">
            <s>{t('nwsDiscountCard.standardPriceOld')}</s> {t('nwsDiscountCard.standardPriceNew')}
          </span>
        </Flex>
        <Flex className="flex-col gap-1 rounded-2xl bg-indigo-crush-04 p-3.5">
          <span className="typo-lg font-extrabold text-indigo-crush">
            {t('nwsDiscountCard.vipSave')}
          </span>
          <span className="typo-xs text-space-75">{t('nwsDiscountCard.vipSaveLabel')}</span>
          <span className="typo-2xs text-space-60">
            <s>{t('nwsDiscountCard.vipPriceOld')}</s> {t('nwsDiscountCard.vipPriceNew')}
          </span>
        </Flex>
      </div>

      <Flex className="items-center gap-2.5 rounded-2xl border-[1.5px] border-dashed border-indigo-crush-40 bg-indigo-crush-04 px-4 py-3.5">
        <Flex className="flex-1 flex-col gap-0.5">
          <span className="typo-2xs font-bold tracking-[0.1em] text-space-60 uppercase">
            {t('nwsDiscountCard.discountCodeLabel')}
          </span>
          <span className="font-mono text-xl font-semibold tracking-[0.08em] text-space">
            {DISCOUNT_CODE}
          </span>
        </Flex>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => copy(DISCOUNT_CODE)}
          className="whitespace-nowrap">
          {isCopied ? t('nwsDiscountCard.copied') : t('nwsDiscountCard.copy')}
        </Button>
      </Flex>

      <Flex className="flex-col gap-1.5">
        <Button asChild className="w-full !text-white">
          <a href={TICKETS_URL} target="_blank" rel="noopener noreferrer">
            {t('nwsDiscountCard.claimButton')}
          </a>
        </Button>
        <span className="text-center typo-xs text-space-60">{t('nwsDiscountCard.claimHint')}</span>
      </Flex>
    </>
  );
};

export default memo(NWSDiscountCardUnlocked);
